<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
   <!-- ここに結果を表示 -->
   
  <h2 class="vy-kojin-title">{{ title }}</h2>
  <article style="padding:0 10px">
    <!-- パンくずリスト -->
    <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" >
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#" v-on:click="Return_home">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
      </ol>
    </nav>

    <div id="manual_area">
      <span v-on:click="manual_open"><img class="m_icon" src="../../../images/mark/manual.png"  />受入先のマニュアル</span>
      <span v-on:click="qanda_open"><img class="m_icon" src="../../../images/mark/QandA.png"  />システムQ&A</span>
    </div>
    <br clear="all"/>

    <div id="List_button_area" v-if="!from">
       <!--
        利用者の場合かつ政令都市向けオプション適用済みなら以下の項目は表示・非表示をチェックすること
        GlobalData.shakyouser_gamen[5]・・・受入先新規登録
        -->
      <button v-if="GlobalData.shakyouser_gamen[5] == 1" class="btn mx-aut btn-secondary" style="width: 180px; height: 50px;padding: 0" v-on:click="facility_add()">新規登録</button>
      <span class="balloon_parent" style="width: 180px; height: 50px;padding: 0;margin-left:10px">
        <button class="btn mx-aut btn-secondary" style="width:100%;height:50px;background-color: green;" v-on:click="mail()">メール履歴</button>
        <span class="balloon-top-right">
          左側サイドバーの条件で絞り込んだユーザーのメール履歴を確認します。
        </span>
      </span>
    </div>

    <div>
      <div id="page_area" style="display: flex;justify-content: space-between;">
        <div style="width:300px;text-align: left;font-size:13px;color: red;display: flex">
          <b v-if="over_count" style="display: flex;justify-content: center;flex-direction: column;">※1000件以上は表示できません。</b>
        </div>
<!--
        <b>
          <button v-on:click="back()" class="btn btn-primary btn-page" >＜</button>
          {{ check_page }} / {{ all_page }}
          <button v-on:click="forward()" class="btn btn-primary btn-page" >＞</button>
        </b>
-->
        <div id="kensu_area">
          <b>{{ kensu }} 件</b>
<!--
            表示件数：
          <select class="Change_count" name="Change_count" v-model="page_read_count" v-on:change="Count_change">
            <option value="10" selected>10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
-->
        </div>
      </div>

      <!-- 受入先一覧 -->
      <!-- <div align="left" v-for="(facility,i) in results" v-bind:key="facility.facility_id"> -->
      <div align="left" v-for="(facility) in results" v-bind:key="facility.facility_id">
        <table border="1" rules="all"  style="width:100%;border-collapse:collapse;cursor:pointer;">
          <!-- 受入先IDと名称 -->
          <tr>
            <td style="padding:2pt 6pt;background-color:royalblue;color:white;border-bottom: 1px solid #FFF;display: flex;justify-content: flex-start;align-items: center;">
              <!-- <div v-on:click="shosai(facility.facility_code)" style="font-size:20px;width: 87%;padding-right: 100px;"><u>{{ i+1 }}：{{facility.facility_name }}</u></div> -->
              <div v-if="from" v-on:click="shosai_select(facility)" style="font-size:20px;width: 87%;">
                <u>{{facility.facility_name }}</u>
              </div>
              <div v-else v-on:click="shosai(facility.facility_code)" style="font-size:20px;width: 87%;">
                <u>{{facility.facility_name }}</u>
              </div>
              <div style="width: 180px;padding: 0px;" v-if="!from">
                <button class="btn btn-secondary bootstrap-only" style="padding:6px 12px;font-size:0.9rem;border-radius:5px;cursor:pointer;" v-on:click="facility_login(facility.facility_code)">受入先システム情報</button>
              </div>
            </td>
          </tr>
          <!-- 受入先住所 -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">受入先住所</b>
                <b style="width:10%;min-width:100px" class="sp_only">受入先住所</b>
                <div class="program_naiyo">{{facility.facility_jusyo}}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">受入先住所</b>
                <b style="width:10%;min-width:100px" class="sp_only">受入先住所</b>
                <div class="program_naiyo">{{facility.facility_jusyo}}</div>
              </div>
            </td>
          </tr>
          <!-- 受入先電話番号 -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">電話番号</b>
                <b style="width:10%;min-width:100px" class="sp_only">電話番号</b>
                <div class="program_naiyo">{{facility.facility_tel}}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">電話番号</b>
                <b style="width:10%;min-width:100px" class="sp_only">電話番号</b>
                <div class="program_naiyo">{{facility.facility_tel}}</div>
              </div>
            </td>
          </tr>
          <!-- 受入先FAX番号 -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">FAX番号</b>
                <b style="width:10%;min-width:100px" class="sp_only">FAX番号</b>
                <div class="program_naiyo">{{facility.facility_fax}}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">FAX番号</b>
                <b style="width:10%;min-width:100px" class="sp_only">FAX番号</b>
                <div class="program_naiyo">{{facility.facility_fax}}</div>
              </div>
            </td>
          </tr>
          <!-- 受入先Eメールアドレス -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">Eメールアドレス</b>
                <b style="width:10%;min-width:100px" class="sp_only">Eメールアドレス</b>
                <div class="program_naiyo">{{facility.facility_email}}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">Eメールアドレス</b>
                <b style="width:10%;min-width:100px" class="sp_only">Eメールアドレス</b>
                <div class="program_naiyo">{{facility.facility_email}}</div>
              </div>
            </td>
          </tr>
          <!-- 受入先担当者名 -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">担当者名</b>
                <b style="width:10%;min-width:100px" class="sp_only">担当者名</b>
                <div class="program_naiyo">{{facility.facility_tantou}}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">担当者名</b>
                <b style="width:10%;min-width:100px" class="sp_only">担当者名</b>
                <div class="program_naiyo">{{facility.facility_tantou}}</div>
              </div>
            </td>
          </tr>
          <!-- QRコード読取り -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">QRコード読取り</b>
                <b style="width:10%;min-width:100px" class="sp_only">QRコード読取り</b>
                <div class="program_naiyo">
                  <span v-if="facility.qr_read_flg">可</span>
                  <span v-else>不可</span>
                </div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">QRコード読取り</b>
                <b style="width:10%;min-width:100px" class="sp_only">QRコード読取り</b>
                <div class="program_naiyo">
                  <span v-if="facility.qr_read_flg">可</span>
                  <span v-else>不可</span>
                </div>
              </div>
            </td>
          </tr>
          <!-- 受入先コメント -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">受入先コメント</b>
                <b style="width:10%;min-width:100px" class="sp_only">受入先コメント</b>
                <div class="program_naiyo" style="white-space: pre-wrap;">{{facility.facility_comment}}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">受入先コメント</b>
                <b style="width:10%;min-width:100px" class="sp_only">受入先コメント</b>
                <div class="program_naiyo" style="white-space: pre-wrap;">{{facility.facility_comment}}</div>
              </div>
            </td>
          </tr>
          <!-- 受入先備考 -->
          <tr v-if="from" v-on:click="shosai_select(facility)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">受入先備考</b>
                <b style="width:10%;min-width:100px" class="sp_only">受入先備考</b>
                <div class="program_naiyo" style="white-space: pre-wrap;">{{facility.facility_bikou}}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-on:click="shosai(facility.facility_code)">
            <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
              <div style="display: flex;align-items: center;">
                <b style="width:150px" class="pc_only">受入先備考</b>
                <b style="width:10%;min-width:100px" class="sp_only">受入先備考</b>
                <div class="program_naiyo" style="white-space: pre-wrap;">{{facility.facility_bikou}}</div>
              </div>
            </td>
          </tr>
        </table><br>
      </div>
    </div>
  </article>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, login_check, Search_timestamp } from '../../js/userdata_shakyo.js'
// ライブラリの指定
import axios from 'axios'
login_check()

const router = useRouter();
const route = useRoute();

const emit = defineEmits(['call'])

let over_count = false //1000件を超えた場合のメッセージを表示

let title = "受入先一覧"

let cityname = route.params.shakyo

let from = ref(false)
// 親コンポーネント（ShakyoFacility.vue）から送られてきた値
// param = {"results":results,"page":page,"page_read_count":page_read_count}
const props = defineProps(['param']);
let results = ref(props.param.results) // 情報が全件入った配列
// let check_page = ref(props.param.page) // 現在のページ数
// let page_read_count = ref(props.param.page_read_count) //表示件数
if(props.param.from != null){
    from = ref(props.param.from)
}

// 全件数
let kensu = ref(0) 
if(props.param.all_count == 0){
    kensu.value = 0;
    // check_page.value = 0;
}else{
    kensu.value = props.param.all_count;//全件数は全てのレコードの最後にくっついている
}

// let all_page = ref(Math.ceil(kensu.value / page_read_count.value)) // 全ページ数 全件数 / 読み込み件数でページ数を取得

//項目を並び替える
//let Sort = function(komoku,mode){ 
//  // 親コンポーネントへ、並び替えたい項目と昇順・降順の指定を送る
//  emit('call',{cmd:'sort',komoku:komoku,mode:mode});
//}

/*
let page_change = function(){

  // 親コンポーネントへページ数変更を伝える
  emit('call',{cmd:'page_change',page0:check_page.value, page_read_count0:page_read_count.value});

}
*/

/*
// 表示件数を変更する
let Count_change = function(){

  check_page.value = 1
  // 親コンポーネントへ件数変更を伝える
  emit('call',{cmd:'count_change',page0:check_page.value, page_read_count0:page_read_count.value});

}
*/

/*
//ページを戻る
const back = () => {
  //　変更後のページ数が0になるようであれば処理を行わない
  if(check_page.value-1 == 0){
      return;
  }else{
      check_page.value -= 1;
  }

  page_change()
}
*/

/*  
// ページを進める
const forward = () => {
    // 現在ページ数が全ページ数を超えるようであれば処理を行わない
    if(check_page.value == all_page.value){
        return;
    }else{
        check_page.value += 1;
    }
    
    page_change()
}
*/

/*
// すべてチェックにチェックしたとき
let all_user_check = function(){
  user_check.value = []
    if(all_check.value == false){
      
      for(let r = 0;r<results.length;r++){
        let result = results[r]
        user_check.value[user_check.value.length] = result.taikenuser_id
      }
    }
}
*/

//------------------- 洗濯後親画面に戻る
const shosai_select = (facility) => { 
  // 選択画面からの画面表示の場合は明細をクリックしたら受入先IDと名称を親画面に渡して画面を閉じる
  emit('call',{cmd:'selected',facility_id:facility.facility_id,facility_name:facility.facility_name,facility:facility});
}

//------------------- 受入先詳細表示へ
const shosai = (f_cd) => { 

  // 親コンポーネントでスクロール位置を保存する
    emit('call',{cmd:'scroll_position'});
    router.push('/'+cityname+'/Kanri/Facility/detail/'+f_cd) 

  }

// メッセージ確認
let message_check_error = 0
let message_check = function(){
    let send_array = {"choson_code":GlobalData.choson_code,"kubun":8,"rireki_check":0}
    
    if(bunrui1.value != "" && bunrui1.value != "全て"){
      send_array.bunrui1 = bunrui1.value
    }
  //---------------- 操作履歴を取得
  axios.post(GlobalData.$API_URL+"Rireki_get", send_array,GlobalData.$ID_Token
          ).then(response => {
            if(response.data.rireki_kanri.length != 0){
              message.value = 1
            }
  }).catch(error => {
    
    if(message_check_error == 6){
        alert(error + GlobalData.$axios_error)
    }else{
        message_check_error++
        setTimeout(function(){message_check()},"1000")
    }
  })
}

/* コンポーネントの表示に関わる処理 */
let Return_home = function(){
    
    router.push('/'+GlobalData.shakyo+'/Kanri')
}

let facility_add = function(){
    router.push('/'+GlobalData.shakyo+'/Kanri/Facility/add')
}

let facility_login = function(facility_code){
  
        let facility_url =  location.protocol+"//"+location.host+"/"+route.params.shakyo+"/"+facility_code+"/shisetsu"
   
    emit('call',{cmd:'open_Facility_login', facility_url:facility_url});

  }

let mail = function(){

//    let disp_facilityid = []

//    for(let i = 0;i<results.value.length;i++){
//        disp_facilityid.push(results.value[i].facility_id)
//    }

//    localStorage.setItem('disp_facilityid',disp_facilityid)
    router.push('/'+GlobalData.shakyo+'/Kanri/Facility/mail')

  }

/*
let Mail_send = function(){
  if(user_check.value.length == 0){
    alert("メールを送信したいユーザーが選択されていません。")
  }else{
    // 親コンポーネントへ、メール送信ウィンドウを開くよう命令する
    emit('call',{cmd:'mail_send',syurui:6,user_id:user_check.value});
  }
}
*/

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/389c0be34f8f807c8378e42133f82a9a"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")
}

</script>

<style>
#kensu_area{
  text-align: right;
  width: 300px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
#kensu_area b{
  margin-right:20px;
}
#page_area{
  margin:10px 0;
  text-align: center;
}
#page_area button{
  margin:0 10px;
  height: 33px;
  padding-top: 0;
  padding-bottom: 0;
}

.sort_button{
  margin-left: 5px;
}

.btn-page{
    height: 33px;
    padding-top: 0;
    padding-bottom: 0;
}

.vy-search-result-row-head,.vy-search-result{
 text-align: left; 
}


#List_button_area{
    width: 100%;
    display: flex;
    justify-content: center;
}

#List_button_area a{
    width: 30%;
    max-width: 200px;
    margin: 10px;
}

#List_button_area button{
  font-size:0.85rem
}
.vy-search-result-row-a{
  cursor: pointer;
}

.del{
  cursor: pointer;
  background-color:pink;
}

.program_naiyo{
  width:90%;
  margin-left:10px
}

</style>


<style scoped>

.balloon_parent:hover .balloon-top2 {
  display: inline;                /* インライン要素として表示 */
}
.balloon-top2 {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  left : -210px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 350px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top2:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 60%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}


.balloon_parent:hover .balloon-top-right {
  display: inline;                /* インライン要素として表示 */
}
.balloon-top-right {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  right : 50px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 500px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top-right:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  right : 10%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}
.bootstrap-only {
  all: revert; /* ← ブラウザ標準へ戻す。custom CSS を消す */
}
</style>